import React from 'react';

// eslint-disable-next-line @nx/workspace/no-restricted-imports-clone
import {
  AccordionItem as ChakraAccordionItem,
  forwardRef,
} from '@chakra-ui/react';

import { AccordionItemProps } from './types';

const AccordionItem = forwardRef<AccordionItemProps, 'div'>(
  ({ children, ...props }, ref) => {
    return (
      <ChakraAccordionItem ref={ref} {...props}>
        {children}
      </ChakraAccordionItem>
    );
  }
);

export { AccordionItem };
